import axios from 'axios'
import router from '../router'
import {Message,MessageBox} from 'element-ui'


// axios.defaults.baseURL = 'http://gps.zhiysoft.com:9220';//正式服务器
axios.defaults.baseURL = process.env.NODE_ENV === "development"?'http://localhost:8080':"http://app.sunningsoft.com:8102";//测试服务器
axios.defaults.carURL = 'http://zzqgkl.oss-cn-beijing.aliyuncs.com/car/attachment/car.png';
axios.defaults.headerPhoto = axios.defaults.baseURL + "/images/header.jpg";


// axios.defaults.withCredentials = false;

axios.create({
  baseURL: axios.defaults.baseURL, // api 的 base_url
  timeout: 8000 // request timeout
});

axios.interceptors.request.use(config => {
  return config;
}, err => {
  Message.error({message: '请求超时!'});
  return Promise.resolve(err);
});


axios.interceptors.response.use(data => {
  // if (data.status && data.status !== 200) {
  //   Message.error({message: data.data.msg});
  //   return;
  // }
  return data;
}, err => {
  console.log(err);
  if (err.response) {
    if (err.response.status == 504 || err.response.status == 404) {
      Message.error({message: '地址不存在,请联系管理员⊙﹏⊙∥'});
      router.push({path: "/"});
    } else if (err.response.status == 403) {
      Message.error({message: '权限不足,请联系管理员!'});
    }else if (err.response.status == 401) {
      MessageBox.alert('您的会话已过期，请重新登录', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          router.push({path: "/"});
        }
      });

    } else {
      Message.error({message: 'net work error!'});
    }
  } else {
    if (err.config.url.startsWith("http://remotecamserver.ligoor.com:8586")) {
      Message.error({message: 'net work error', center: true});
    } else {
      Message.error({message: 'net work error', center: true});
      // router.push({path: "/"});
    }
  }
  return Promise.resolve(err);
});

let token = "";

export const postRequest = (url, params) => {
  return axios({
    method: 'post',
    url: `${url}`,
    data: params
  });
}
export const putRequest = (url, params) => {
  return axios({
    method: 'put',
    url: `${url}`,
    data: params
  });
}
export const deleteRequest = (url) => {
  return axios({
    method: 'delete',
    url: `${url}`
  });
}

export const getRequest = (url, params) => {
  return axios({
    method: 'get',
    url: `${url}`,
    params: params
  });
}



// WEBPACK FOOTER //
// ./src/utils/api.js